import { useQuery } from '@tanstack/react-query';
import { RQAPICallWithData } from 'store/APIClient';
import { BlogArticle } from '../models/BlogArticle';

export const useGetBlogArticles = () =>
    useQuery({
        queryKey: ['blog_articles'],

        queryFn: async () => {
            const response = await RQAPICallWithData<BlogArticle[]>({
                endpoint: 'blog/articles',
                method: 'GET',
            });
            return response.content.data;
        },
    });
